// PnL Takip veri erişimi. Karşılığı: src/shadow/api/app.py (/api/pnl) —
// hesap src/shadow/store/pnl.py içinde yapılır, buraya HAZIR gelir.
//
// Tüm hacimler MWh, tutarlar TL, fiyatlar TL/MWh — arayüz lot görmez ve
// hiçbir PnL değerini kendisi hesaplamaz (iki ayrı hesap yolu yarışmasın).

/** Bir işlem bacağı: hacim (MWh) + ağırlıklı ortalama fiyat (TL/MWh). */
export interface PnlLeg {
  mwh: number
  aof: number | null
}

export interface PnlRow {
  date: string // YYYY-MM-DD (teslim günü)
  hour: number // 0–23 (teslim saati)
  contract: string
  closed: boolean
  ptf: number | null
  /** SMF açıklanmadıysa sunucu PTF'yi koyar ve `smfProvisional` işaretler. */
  smf: number | null
  smfProvisional: boolean
  /** Net talimat (sistem yönü): + YAL/enerji açığı, − YAT/enerji fazlası. */
  talimat: number | null
  /** Açık kontratın bekleyen pozisyonu (MWh) — PnL'e girmez. */
  openPosition: number | null
  buy: PnlLeg
  sell: PnlLeg
  imbalance: { mwh: number | null; posPrice: number | null; negPrice: number | null }
  totalBuy: PnlLeg
  totalSell: PnlLeg
  /** Eşleşen (gidiş-dönüş) hacim — TL/MWh paydası ve hacim kartı bundan. */
  matchedMwh: number
  /**
   * Dengesizlik ödeşmesinin vade/faiz etkisi (TL) — PnL'e DAHİL.
   * Kısa pozisyon getiri (+), uzun pozisyon maliyet (−); açık kontratta null.
   */
  financialImpact: number | null
  pnlTl: number | null
  pnlPerMwh: number | null
  pnlPctPtf: number | null
}

/** Gün alt-toplamı / aralık özeti — satırla aynı alanlar, saat bilgisi yok. */
export interface PnlTotals {
  openPosition: number | null
  /** Dolumu olan saat sayısı — aylık görünümde günün "kaç saat" sütunu. */
  activeHours: number
  /** Eşleşen hacimle ağırlıklı PTF (eşleşen yoksa düz ortalama). */
  ptfAvg: number | null
  buy: PnlLeg
  sell: PnlLeg
  imbalance: { mwh: number | null }
  totalBuy: PnlLeg
  totalSell: PnlLeg
  matchedMwh: number
  financialImpact: number | null
  pnlTl: number
  pnlPerMwh: number | null
  pnlPctPtf: number | null
}

export interface PnlDay {
  date: string
  rows: PnlRow[] // her zaman 24 satır (0–23)
  total: PnlTotals
}

export interface PnlReport {
  since: string
  until: string
  days: PnlDay[] // eskiden yeniye
  summary: PnlTotals
}

export async function fetchPnl(since: string, until: string): Promise<PnlReport> {
  const p = new URLSearchParams({ since, until })
  const response = await fetch(`/api/pnl?${p}`)
  if (!response.ok) {
    let mesaj = `PnL alınamadı (${response.status})`
    try {
      const body = await response.json()
      if (typeof body?.detail === 'string') mesaj = body.detail
    } catch {
      /* gövde JSON değil */
    }
    throw new Error(mesaj)
  }
  return response.json()
}
